export const cards = {
  setAllCards: 'get_all_cards',
  openAllCards: 'open_all_cards',
  closeAllCards: 'close_all_cards',
  resetCards: 'reset_cards',
  setFirstOption: 'set_first_option',
  setSecondOption: 'set_second_option',
  clearOptions: 'clear_options',
  setOpenCard: 'set_open_card',
  setCloseCard: 'set_close_card',
  setComparing: 'set_comparing',
  addCardsPaired: 'add_cards_paired',
  clearCardsData: 'clear-cards-data'
};

export const points = {
  updateBestPuntuation: 'update_best_point',
  addPoints: 'add_points',
  addAttempt: 'attempts',
  clearPointsData: 'clear_points_data'
};

export const user = {
  addUserName: 'add_username'
}
export const ui = {
  openModal: 'open_modal',
  closeModal: 'close_modal'
}